import { SeDateTimeString, SeDateTimeOptions } from './date-time-types'
import { SePointFormatter } from './point-formatter'
import { SeDateFormatter } from './date-formatter'
import { extendClass } from './extend-class'

export class SeDate {

  constructor(
    dateValue: SeDateTimeString,
    options: SeDateTimeOptions
  ) {
    this.initDate(dateValue, options)
    this.initPoint(dateValue, options)
  }

  public get value(): string {
    return this.luxon.toISODate() || undefined
  }

  public toString(): string {
    return this.value
  }

}

export interface SeDate extends SeDateFormatter, SePointFormatter {}
extendClass(SeDate, SeDateFormatter, SePointFormatter)
